import React from "react";
import { RichTextFieldType } from "../fields/rich-text";
import RichText from "../../lib/components/format/rich-text";

const richTextToReactElement = (content: RichTextFieldType): React.ReactElement => {
  return <RichText content={content} />;
};

export default richTextToReactElement;
